// Modals used only by the epos screen.
// Each of these modals should be registered in src/epos/vue/eposVueInit.js
// And the source for each modal should be in src/epos/vue/modals
const MODAL_NAMES__EPOS = {
    ABOUT: 'AboutModal',
    ADDRESS: 'AddressModal',
    ADJUST_FLOAT: 'AdjustFloatModal',
    ADD_GOCARDLESS_BANK_ACCOUNT: 'AddGoCardlessBankAccountModal',
    CART_FIELDS: 'CartFieldsModal',
    CART_LINE_DETAILS: 'CartLineDetailsModal',
    CART_OFFERS: 'CartOffersModal',
    CART_PREVIEW: 'CartPreviewModalSheet',
    CASH_UP: 'CashUpModal',
    CASH_UP_CONFIRM: 'CashUpConfirmModal',
    CHANGE: 'ChangeModal',
    SEARCH: 'SearchModal',
    CLOVER_TERMINALS: 'CloverTerminalsModal',
    COMPLETE_WAIVER: 'CompleteWaiverModal',
    CUSTOMER_MARKETING_PREFERENCES: 'CustomerMarketingPreferencesModal',
    CUSTOMER_DETAILS: 'CustomerDetailsModal',
    DEBUG: 'DebugModal',
    DOJO_TERMINALS: 'DojoTerminalsModal',
    EPOS_MENU: 'EposMenuModal',
    GIFT_AID: 'GiftAidModal',
    GROUP_BOOKING_REFERENCE: 'GroupBookingReferenceModal',
    HELD_CARTS: 'HeldCartsModal',
    HOLD_CART: 'HoldCartModal',
    KITCHEN_ORDERS: 'KitchenOrdersModal',
    MANAGE_GOCARDLESS: 'ManageGoCardlessModal',
    MELLON_WEBECR_API_KEYS: 'MellonWebECRApiKeysModal',
    MELLON_WEBECR_RECOVERY: 'MellonWebECRRecoveryModal',
    MELLON_WEBECR_REDEEM: 'MellonWebECRTRedeemModal',
    MELLON_WEBECR_TRANSACTIONS: 'MellonWebECRTransactionsModal',
    MEMBERS_CONFIRM: 'MembersConfirmModal',
    MEMBERSHIP_CANCELLATION: 'MembershipCancellationModal',
    MEMBERSHIP_INSTALLMENTS: 'MembershipInstallmentsModal',
    MEMBERSHIP_RENEWAL_DATE: 'MembershipRenewalDateModal',
    MERGE_CART: 'MergeCartModal',
    NEW_ORDER_WAIVERS: 'NewOrderWaiversModal',
    ORDER_ERROR: 'OrderErrorModal',
    ORDER_EMAIL_RECEIPT: 'OrderEmailReceiptModal',
    ORDER_NOTES: 'OrderNotesModal',
    ORDER_OUTSTANDING_BALANCE: 'OrderOutstandingBalanceModal',
    ORDER_PAYMENT_DETAILS: 'OrderPaymentDetailsModal',
    ORDER_PAYMENTS: 'OrderPaymentsModal',
    ORDER_PREVIEW: 'OrderPreviewModal',
    PARTIAL_PAYMENT: 'PartialPaymentModal',
    // Payment modal is only partially migrated to Vue.
    PAYMENT_ERROR: 'PaymentErrorModal',
    PAYMENT_TOKEN_SELECTION: 'PaymentTokenSelectionModal',
    PAYYO_CONFIGURE_TIPS: 'PayyoConfigureTipsModal',
    PAYYO_MANUAL_RECONCILIATION: 'PayyoManualReconciliationModal',
    PAYYO_PAYMENT_DETAILS: 'PayyoPaymentDetailsModal',
    PAYYO_TERMINALS: 'PayyoTerminalsModal',
    PAYYO_TERMINAL_REGISTRATION: 'PayyoTerminalRegistrationModal',
    PHOTO_SELECTOR: 'PhotoSelectorModal',
    PRICE_EDIT: 'PriceEditModal',
    REFUNDABLE_PAYMENTS: 'RefundablePaymentsModal',
    SEND_TO_KITCHEN: 'SendToKitchenModal',
    SIMULATE_PAYYO_PAYMENT: 'SimulatePayyoPaymentModal',
    SESSION_PICKER: 'SessionPickerModal',
    SETTINGS: 'SettingsModal',
    SOLD_GIFT_VOUCHER_DATA: 'SoldGiftVoucherDataModal',
    SPLIT_PAYMENT: 'SplitPaymentModal',
    TABLE_PICKER: 'TablePicker',
    TICKET_PICKER: 'TicketPicker',
    TODAY_VIEW_FILTERS: 'TodayViewFiltersModalSheet',
    TRADING_SESSIONS_LIST: 'TradingSessionsListModal',
    VARIABLE_DISCOUNT: 'VariableDiscount',
    WAIVER_CODE: 'WaiverCodeModal',
};

module.exports = {
    MODAL_NAMES__EPOS,
};
